export default __webpack_public_path__ + "static/media/gallery_00.14e5dab2.jpg";